import { render, staticRenderFns } from "./Detail-Property.vue?vue&type=template&id=daaf6994&"
import script from "./Detail-Property.vue?vue&type=script&lang=js&"
export * from "./Detail-Property.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports